module.exports = ".mandatory{\r\n    color:red;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/prospect/unify-marketing-details/unify-marketing-details-form/unify-marketing-details-form.component.css
// module id = ./src/app/prospect/unify-marketing-details/unify-marketing-details-form/unify-marketing-details-form.component.css
// module chunks = main